import { Component, OnInit, Input, isDevMode } from '@angular/core';

@Component({
  selector: 'app-view-port-information',
  templateUrl: './view-port-information.component.html',
  styleUrls: ['./view-port-information.component.scss']
})
export class ViewPortInformationComponent implements OnInit {
  @Input() position: string = 'landing-page';
  devMode: boolean;

  constructor() { }

  ngOnInit() {
    this.devMode = isDevMode();
  }
}
